import React, {useEffect, useState} from 'react';
import {auswahlProducts} from '../../assets/images/data';
import {Link} from 'react-router-dom';
import {connect} from "react-redux";
import {updateHeader, updateUrl, hideEditProduct} from '../store/actions/main';
import {updateProductIndexStahltreppe} from '../store/actions/stahltreppen';
import ModalPopUp from '../module/modalPopUp';
import {StepComponent} from '../module/step_component';

const Auswahl = (props) => {
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => setShowModal(false);
    const [titelModell, setTitelModell] = useState('');

    useEffect(() => {
        props.updateHeader("Auswahl");
        updateItems();
    })

    const updateItems = () => {
        //editProduct();
    }

    // const editProduct = () => {
    //     let category = props.main_data[3].editProduct[0].editCategory;
    //     let isEditProduct = props.main_data[3].editProduct[0].isEditProduct;

    //     if (isEditProduct) {
    //         switch (category) {
    //             case 'Stahltreppe':
    //                 props.updateUrl('Stahltreppe');
    //                 setTitelModell(category);
    //             break;
    //             case 'Pforte':
    //                 props.updateUrl('Pforte');
    //                 setTitelModell(category);
    //             break;
    //             case 'Zaun':
    //                 props.updateUrl('Zaun');
    //                 setTitelModell(category);
    //             break;
    //             default:
    //                 return category;

    //         }
    //         setShowModal(true);
    //         props.hideEditProduct();
    //     }

    // }

    const openProduct = ev => {
        let titel = ev.currentTarget.getAttribute('titel');

        props.updateUrl(titel);
        setTitelModell(titel);
        setShowModal(true);
        updateItems();
    }

    return(
         <div className="AuswahlWrapper">
             <div className="productWrapper">
                 {auswahlProducts.map((product, index) => {
                      return(
                        <Link onClick={openProduct} titel={product.titel} to={product.path} key={index} className="navlink">
                          <div className="innerWrapper">
                              <img className="imgAuswahl" src={product.imgsrc} alt={product.titel} />
                              <h2>{product.titel}</h2>
                          </div>
                        </Link>
                      )
                 })}
             </div>
             <ModalPopUp
                  title={titelModell}
                  class='modell'
                  component={<StepComponent />}
                  showModal={showModal}
                  hideModal={closeModal}
              />
         </div>
    )
}

const mapStateToProps = state => {
    return {
        main_data: state.mainReducer.data,
    }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        hideEditProduct: () => dispatch(hideEditProduct()),
        updateProductIndexStahltreppe: ev => dispatch(updateProductIndexStahltreppe(ev))
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Auswahl);